import { getRgObjectsOfType as g, RG_TYPE as c } from "@project-rouge/rg-core";
import { getLevelGIA as s } from "./index20.js";
import { getLevelNIA as u } from "./index25.js";
const v = (l, e) => {
  let i = 0, o = 0;
  const r = g(l, c.Building);
  for (const t of r) {
    const f = t.data.levels.filter((n) => n.levelIndex === e);
    !f.length || f.every((n) => n.isRoof) || (i += s(t, e), o += u(t, e));
  }
  return i === 0 ? 0 : o / i;
};
export {
  v as getLevelEfficiency
};
//# sourceMappingURL=index15.js.map
